import React from 'react';
import { Instagram, Youtube, Mail, ArrowUpRight } from 'lucide-react';
import { influencerData, navLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#111111] border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <a href="#" className="text-2xl font-bold text-white tracking-tight mb-4 block">
              MARCUS<span className="text-[#FF3B3B]">.</span>STEEL
            </a>
            <p className="text-[#9CA3AF] text-sm leading-relaxed max-w-md mb-6">
              Elite fitness influencer partnering with premium brands to create authentic content that drives real results. Based in Los Angeles, available worldwide.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#9CA3AF] hover:bg-[#FF3B3B] hover:border-[#FF3B3B] hover:text-white transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#9CA3AF] hover:bg-[#FF3B3B] hover:border-[#FF3B3B] hover:text-white transition-all duration-300"
              >
                <Youtube size={18} />
              </a>
              <a
                href={`mailto:${influencerData.email}`}
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-[#9CA3AF] hover:bg-[#FF3B3B] hover:border-[#FF3B3B] hover:text-white transition-all duration-300"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#9CA3AF] hover:text-[#FF3B3B] transition-colors duration-300 text-sm flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${influencerData.email}`}
                  className="text-[#9CA3AF] hover:text-[#FF3B3B] transition-colors duration-300 text-sm"
                >
                  {influencerData.email}
                </a>
              </li>
              <li className="text-[#9CA3AF] text-sm">
                Los Angeles, California
              </li>
              <li className="text-[#9CA3AF] text-sm">
                Available for worldwide collaborations
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#9CA3AF] text-sm">
            © {new Date().getFullYear()} Marcus Steel. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#9CA3AF] hover:text-white transition-colors duration-300 text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-[#9CA3AF] hover:text-white transition-colors duration-300 text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
